const closeAlertButtons = document.querySelectorAll('.close-alert');

export default function initFormAlerts() {
    if (closeAlertButtons) {
        closeAlertButtons.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.stopPropagation();

                document.querySelector('.alert').classList.add('hidden');
            });
        });
    }
}
